import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { CgGitFork } from "react-icons/cg";

import { AiOutlineHome } from "react-icons/ai";
import { FaFlask, FaBook, FaCamera, FaGamepad } from "react-icons/fa";
import { BsFillSunFill, BsFillMoonStarsFill } from "react-icons/bs";

import brandLogo from "../Assets/image.png";
import { FONT_PRESETS } from "../fonts";

function NavBar({ theme, toggleTheme, fontId, setFontId }) {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  // Update the sticky style on scroll. Registered once with a passive listener
  // and rAF throttling (the previous code re-added a listener every render).
  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        updateNavbar(window.scrollY >= 20);
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container fluid className="nav-container">
        <Navbar.Brand as={Link} to="/" className="nav-brand">
          <img src={brandLogo} alt="Harsh Gupta" className="brand-logo" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="nav-links-left" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/lab"
                onClick={() => updateExpanded(false)}
              >
                <FaFlask style={{ marginBottom: "2px" }} /> Code Lab
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/journal"
                onClick={() => updateExpanded(false)}
              >
                <FaBook style={{ marginBottom: "2px" }} /> Journal
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/frames"
                onClick={() => updateExpanded(false)}
              >
                <FaCamera style={{ marginBottom: "2px" }} /> Frames
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/arena"
                onClick={() => updateExpanded(false)}
              >
                <FaGamepad style={{ marginBottom: "2px" }} /> Arena
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <div className="nav-actions">
            <label className="font-picker">
              <span className="visually-hidden">Site font</span>
              <select
                value={fontId}
                onChange={(e) => setFontId(e.target.value)}
                aria-label="Site font"
              >
                {FONT_PRESETS.map((preset) => (
                  <option
                    key={preset.id}
                    value={preset.id}
                    style={{ fontFamily: preset.body }}
                  >
                    {preset.label}
                  </option>
                ))}
              </select>
            </label>

            <div
              className={`theme-toggle ${
                theme === "light" ? "is-light" : "is-dark"
              }`}
            >
              <span className="theme-toggle-thumb" />
              <button
                type="button"
                className="theme-opt"
                onClick={() => theme !== "dark" && toggleTheme()}
                aria-label="Dark mode"
                aria-pressed={theme === "dark"}
              >
                <BsFillMoonStarsFill />
              </button>
              <button
                type="button"
                className="theme-opt"
                onClick={() => theme !== "light" && toggleTheme()}
                aria-label="Light mode"
                aria-pressed={theme === "light"}
              >
                <BsFillSunFill />
              </button>
            </div>

            <Button
              href="https://github.com/DevilsN3st"
              target="_blank"
              className="fork-btn-inner"
            >
              <CgGitFork
                className="fork-git-icon"
                style={{ fontSize: "1.2em" }}
              />
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
